// extracted by css-extract-rspack-plugin
export default {"TableContainer":"x0CfI","Table":"YaoEF","HeaderCell":"KzFMi","BodyRow":"zQ2Gz","BodyCell":"Wydzz","LimitInput":"PKO8J","InputWrapper":"jl5yi"};